import styled from 'styled-components';
import { FONT_FAMILY, COLORS, DEVICES } from '@Commons';

export const Wrapper = styled.div`
  max-width: 450px;

  @media ${DEVICES.mobileXL} {
    max-width: unset;
    width: 100%;
  }
`;

export const TimeWrapper = styled.div`
  font-size: 12px;
  line-height: 22px;
  color: ${COLORS.textDarkGray};
  margin-bottom: 24px;

  .time {
    font-size: 12px;
    line-height: 22px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.textLightGrey};
  }
`;
export const BankTransferWrapper = styled.div`
  font-size: 18px;
  line-height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  margin-bottom: 8px;
`;

export const WarningWrapper = styled.div`
  display: flex;
  border: 1px solid ${COLORS.lightGrey};
  background: ${COLORS.lightShadedGrey};
  padding: 12px 16px;
  border-radius: 4px;
  margin: 24px 0 48px 0;

  .info-image {
    margin-right: 12px;
    align-self: flex-start;
  }
  .instructions {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.textGrey};
  }
  .styled-word {
    font-family: ${FONT_FAMILY.hellix.bold};
  }
`;

export const ModalWrapper = styled.div`
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  max-width: 500px;
  background-color: ${COLORS.white};
  .closeIcon {
    align-self: end;
    float: right;
    cursor: pointer;
    padding: 4px;
  }
  .modal-subheading {
    font-size: 16px;
    font-family: ${FONT_FAMILY.hellix.regular};
    line-height: 22px;
    color: ${COLORS.textGrey};
    text-align: center;
    margin-bottom: 32px;
    max-width: 418px;
  }
  .modal-heading {
    font-size: 18px;
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.black};
    margin-bottom: 24px;
  }
  .btn-wrapper {
    margin-top: 24px;
  }
`;

export const TextInfo = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.textGrey};
  margin: 48px 0 12px;
  text-align: center;
`;
